module.exports = __webpack_public_path__ + "static/media/300x300.9affd628.png";